import React from "react";

const Chapter9 = () => {
  return (
    <>
      <h2>
        What can I do to help reduce CECs and other pollution in the South
        Platte River?
      </h2>
      <p>
        Understanding what CECs are in our waters and what problems they cause
        is a first step to doing something about it. Public outcry has been a
        big part of a recent ban of the chemical Triclosan (used in soaps,
        detergents, and other products to kill bacteria and fungus), and the
        decline in use of Bisphenol A (or BPA, is a plasticizer that is an
        endocrine disruptor) in products. Proper disposal of unused medications
        can limit the amount of chemicals released to rivers from wastewater
        treatment facilities. Never flush unused medications down the sink or
        toilet and participate in drug take-back programs. Follow instructions
        for proper use and disposal of chemicals including lawn care products.
        Support scientific research on CEC effects and wastewater treatment
        technology. Support wastewater treatment infrastructure improvements.
      </p>
    </>
  );
};

export default Chapter9;
